<template>
  <div v-if="multipleQuotes">
    <swiper class="pt-6 pb-8" :options="swiperOptions">
      <swiper-slide v-for="(quote, index) of quotes" :key="quote.id" class="h-auto">
        <router-link
          v-if="quote.stage === 'sent'"
          :class="{ 'card card-quote-proposal': true, active: quote && quote === selectedCard }"
          :to="routeToName"
          @click.native="selectCard(quote)"
        >
          <Card :countOffer="index + 1" :quote="quote"></Card>
        </router-link>
        <!-- Non active card for redesign/revision -->
        <div
          v-else
          :class="{ 'card card-quote-proposal': true }">
          <Card :countOffer="index + 1" :quote="quote"></Card>
        </div>


      </swiper-slide>

      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <router-view></router-view>
  </div>
  <router-view v-else></router-view>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import Card from './Card'
import 'swiper/css/swiper.css'

export default {
  name: 'ProposalsTemplate',
  components: {
    Card,
    Swiper,
    SwiperSlide,
  },

  data() {
    return {
      selectedCard: null,
      routeToName: {},
      // https://swiperjs.com/swiper-api#parameters
      swiperOptions: {
        centerInsufficientSlides: true,
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 10,
        runCallbacksOnInit: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
        // https://swiperjs.com/swiper-api#events
        on: {
          slideNextTransitionStart: () => {
            this.resetRoute()
          },
          slidePrevTransitionStart: () => {
            this.resetRoute()
          },
        },
      },
    }
  },
  methods: {
    checkActiveCard() {
      return this.quotes.find(({ id }) => id === this.$route.params.id)
    },
    setStartingSlide() {
      this.swiperOptions.initialSlide = this.selectedCard
        ? this.quotes.findIndex(({ id }) => id === this.selectedCard.id)
        : 0
    },
    selectCard(card) {
      if (this.selectedCard && this.selectedCard.id === card.id) {
        this.routeToName = { name: 'ContentProposal' }
      } else {
        this.selectedCard = card
        this.routeToName = { name: 'card-detail', params: { id: card.id } }
      }

      this.$router.push(this.routeToName)
    },
    resetRoute() {
      if (this.selectedCard) {
        this.selectedCard = null
        this.routeToName = { name: 'ContentProposal' }
        this.$router.push(this.routeToName)
      }
    },
    setDetailsArrowPosition() {
      const selectedSlideEl = this.$el.querySelector('.card-quote-proposal.active')
      if (!selectedSlideEl) {
        return
      }

      const detailsEl = this.$el.querySelector('#quote-proposal-detail')
      if (!detailsEl) {
        return
      }

      const { left, width } = selectedSlideEl.getBoundingClientRect()
      const arrowWidth = 40
      const arrowCenter = (Math.sqrt(2) * arrowWidth) / 2 // diagonal of square / 2
      const arrowPosition = left - detailsEl.offsetLeft + width / 2 - arrowCenter

      this.$el.style.setProperty('--arrow-width', `${arrowWidth}px`)
      this.$el.style.setProperty('--arrow-position', `${arrowPosition}px`)
    },
  },
  updated() {
    this.selectedCard = this.checkActiveCard()

    if (this.multipleQuotes) {
      this.setDetailsArrowPosition()
    }
  },
  created() {
    this.selectedCard = this.checkActiveCard()
    this.setStartingSlide()
  },
  mounted() {
    if (this.multipleQuotes) {
      this.setDetailsArrowPosition()
    }
  },
}
</script>

<style lang="scss">
$gray-700: #5c6670;

.swiper-pagination-bullet {
  box-sizing: content-box;
  vertical-align: middle;
  opacity: 1;
  background-color: $gray-700;
  border: 0px solid $gray-700;

  &-active {
    border-width: 2px;
    background-color: transparent;
  }
}
</style>
